import React from 'react';

const Contact = () => (
  <section style={{ padding: 24 }}>
    <h2>Contact Us</h2>
    <p>
      <strong>Phone:</strong> 7667533653, 8072534304<br />
      <strong>Email:</strong> <a href="mailto:onlinecrackers2022@gmail.com">onlinecrackers2022@gmail.com</a><br />
      <strong>Instagram:</strong> <a href="https://instagram.com/onlinecrackers2022" target="_blank" rel="noopener noreferrer">@onlinecrackers2022</a>
    </p>
  </section>
);

export default Contact;
